import {Component, CUSTOM_ELEMENTS_SCHEMA, inject} from '@angular/core';
import {AsyncPipe, NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {Observable, Subject} from "rxjs";
import {SessionService} from "./session.service";
import {Dialog} from "@aileron/dialog";

@Component({
  selector: 'session-dialog',
  imports: [
    NgIf,
    TranslateModule,
    AsyncPipe
  ],
  templateUrl: './session-dialog.component.html',
  styleUrl: './session-dialog.component.scss',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SessionDialogComponent {

  private sessionService = inject(SessionService);

  openModal = false;
  continueDialog = true;

  showDialog$!: Observable<boolean>;
  expiredDialog$!: Observable<boolean>;
  dialogResult$?: Subject<boolean>;

  /**
   * Subscribes to the observables that determine if dialog is open
   * and which type of dialog (warning or expired)
   */
  ngOnInit(){
    this.showDialog$ = this.sessionService.getDialogOpenStream();
    this.expiredDialog$ = this.sessionService.getDialogExpiredStream();
    const sub = this.expiredDialog$.subscribe((value) => {
      if(value){
        this.focus();
        sub.unsubscribe();
      }
    });
  }

  /**
   * Verifies user clicks either the x or the button
   * @param event
   */
  confirmClose(event: Event) {
    if((event as CustomEvent).detail.source !== 'close-button' && (event as CustomEvent).detail.source !== 'keyboard') {
      event.preventDefault();
    } else {
      this.sessionService.dialogResult$!.next(false);
    }
  }

  /**
   * Closes dialog
   * @param value
   */
  closeDialog(): void {
    this.sessionService.dialogResult$!.next(false);
  }

  private focus() {
    setTimeout(() => {
      const dialogElement = document.getElementById('session-timeout-dialog') as HTMLElement;
      dialogElement.focus();
    }, 1);
    this.updateTabElements();
  }

  private updateTabElements() {
    setTimeout(() => {
      const dialogElement = document.getElementById('session-timeout-dialog') as unknown as Dialog;
      dialogElement.updateTabbableElements();
    }, 1);
  }
}
